import React from "react";
import { connect } from "react-redux";
import * as PageRoutes from "../../utils/route_pages";
import * as Assets from "../../utils/svg_assets";
import TopNavigation from "../../components/TopNavigation";
import { Row, Button } from "react-bootstrap";
import { dateFormater } from "../../utils/utilities";
import { Base } from "../../components/RootLayout";
import { useNavigate } from "react-router-dom";
import ApiUtils from "../../utils/api_utils";

export const ShowMyCard = (props) => {
  const navigate = useNavigate();
  const { profile, login } = props;
  const { organization_logo } = login;

  return (
    <Base>
      <TopNavigation
        titlePage="My Card"
        toPath={PageRoutes.account}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div style={{ padding: "25px 50px" }}>
        <div className="my-card">
          <span
            style={{
              fontWeight: "bold",
              fontSize: "large",
            }}
          >
            {profile.organization_name}
          </span>
          <br />
          <img
            src={ApiUtils.validateImgUrl({ url: organization_logo })}
            alt="org_log"
            className="org-img"
          />
          <div
            className="pp-img"
            style={{
              backgroundImage: `url(${ApiUtils.validateImgUrl({
                url: profile.profile_pic_url,
              })})`,
            }}
          ></div>
          <span>{`${profile.first_name} ${profile.last_name}`}</span>
          <br />
          <span>{`NIK ${profile.nik ? profile.nik : ""}`}</span>
          <br />
          <span>{profile.job_title ? profile.job_title : ""}</span>
          <br />
          <span>{profile.email ? profile.email : ""}</span>
          <br />
          <span>{`Joined on ${dateFormater(profile.date_employed)}`}</span>
          <br />
        </div>
      </div>

      <Row className="grouping-btn">
        <Button className="border-0" onClick={() => navigate(PageRoutes.home)}>
          Check My Points
        </Button>
        <Button
          className="border-0"
          onClick={() => navigate(PageRoutes.reward)}
        >
          Redeem My Reward
        </Button>
      </Row>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.ProfileSM.profile,
  login: state.LoginSM.login,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMyCard);
